import { render } from "./userInfo.vue?vue&type=template&id=1a4c9583&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=1a4c9583&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a4c9583"

export default script